/**
 * @fileoverview GET handler for the "/email/ip_warming/:app_group_id/schedule" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { emailIpWarmingAppGroupIdSchedule } from "./constants";
import type { EmailIpWarmingAppGroupIdScheduleParams, EmailIpWarmingAppGroupIdScheduleResult } from "./types";
import { isEmailIpWarmingAppGroupIdScheduleResult } from "./validators";

export const getEmailIpWarmingAppGroupIdSchedule = reactQueryFetcherAdapter(
  emailIpWarmingAppGroupIdSchedule,
  (
    signal: AbortSignal,
    appGroupId: string,
    params: EmailIpWarmingAppGroupIdScheduleParams
  ): Promise<EmailIpWarmingAppGroupIdScheduleResult> => {
    return fetch(
      `/email/ip_warming/${appGroupId}/schedule`,
      "GET",
      { ...params },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isEmailIpWarmingAppGroupIdScheduleResult
);
